import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.set-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames';
import { defineMessages, FormattedMessage } from 'react-intl';
import { PortalContent } from 'components/Portal/PortalContent';
import { CallToAction, ACTIONS } from 'components/CallToAction';
import { CmsCta, CMS_CTA_TYPES } from 'components/CmsPage/modules/CmsCta';
import { LeadGenFormContainer } from 'features/LeadGenForm/LeadGenFormContainer';
import { FriendbuyWidgetContainer } from 'components/Friendbuy/FriendbuyWidgetContainer';
import { CTA_COLOR_BY_NAME } from 'constants/colors';
import { ga } from 'helpers/multitrack';
import { renderMarkdown } from 'helpers/markdown';
import { isEmpty } from 'helpers/verify';
var messages = defineMessages({
  navAction: {
    id: 'hero.nav.action',
    defaultMessage: 'Get ClassPass'
  },
  waitlistAction: {
    id: 'hero.waitlist.action',
    defaultMessage: 'Join the waitlist'
  }
});
/* eslint-disable react/no-array-index-key */

var wrapLines = function wrapLines(lines, className) {
  return (lines || []).map(function (line, idx) {
    return React.createElement("span", {
      className: className,
      key: "line-".concat(idx)
    }, line);
  });
};
/* eslint-enable react/no-array-index-key */


export var HeroV2 =
/*#__PURE__*/
function (_Component) {
  _inherits(HeroV2, _Component);

  function HeroV2(props) {
    var _this;

    _classCallCheck(this, HeroV2);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(HeroV2).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "handleFriendbuyWidgetClose", function () {
      return _this.setState({
        displayFriendbuyWidget: false
      });
    });

    _this.state = {
      displayFriendbuyWidget: false
    };
    _this.handleCtaClick = _this.handleCtaClick.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(HeroV2, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      var _this$props = this.props,
          setPagePromotion = _this$props.setPagePromotion,
          promoAlias = _this$props.promoAlias;
      setPagePromotion(promoAlias);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.useSellHeader(false);
    }
  }, {
    key: "onDwell",
    value: function onDwell() {
      ga('Hero Module', 'Viewed module', null, 0, {
        nonInteraction: true
      });
    } // Logic specific to the hero on CTA click events

  }, {
    key: "handleCtaClick",
    value: function handleCtaClick() {
      var cta = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _this$props2 = this.props,
          localCtaClick = _this$props2.ctaClick,
          isWelcomeHero = _this$props2.isWelcomeHero;

      if (isWelcomeHero && cta.type === CMS_CTA_TYPES.URL) {
        ga('Refer-a-Friend', 'raf-hero-cta-click');
        this.setState({
          displayFriendbuyWidget: true
        });
      } else if (cta.type === CMS_CTA_TYPES.URL || cta.type === CMS_CTA_TYPES.OFFER_CHECKOUT) {
        ga('Hero Module', 'Clicked CTA');
      }

      localCtaClick();
    }
  }, {
    key: "renderCtaSection",
    value: function renderCtaSection() {
      var _this2 = this;

      var ctas = this.props.ctas;
      var renderedCtas = ctas.map(function (cta, idx) {
        var renderedCta = _this2.renderCta(cta, idx === 0);

        return renderedCta && React.createElement("span", {
          className: "hero__cta",
          key: "cta-".concat(cta.copy)
        }, renderedCta);
      }).filter(Boolean);
      return !isEmpty(renderedCtas) && React.createElement("div", {
        className: "hero__main-cta"
      }, renderedCtas);
    }
  }, {
    key: "renderCta",
    value: function renderCta(cta, isPrimary) {
      var _this3 = this;

      if (!cta.copy) {
        return null;
      }

      var interpolator = this.props.interpolator;
      var extraClass = classNames('bt--lg', 'hero__cta__button', _defineProperty({
        'hero__cta__button--video': cta.type === CMS_CTA_TYPES.YOUTUBE_VIDEO
      }, "hero__cta__button--".concat(cta.color), cta.type === CMS_CTA_TYPES.URL && cta.color && !(cta.color in CTA_COLOR_BY_NAME)));
      return React.createElement(CmsCta, _extends({}, cta, {
        copy: interpolator(cta.copy),
        extraClass: extraClass,
        isPrimary: isPrimary,
        onClick: function onClick() {
          return _this3.handleCtaClick(cta);
        }
      }));
    }
  }, {
    key: "renderLeadCapture",
    value: function renderLeadCapture() {
      return React.createElement("div", {
        className: "hero__lead-gen"
      }, React.createElement(FormattedMessage, messages.waitlistAction, function (copy) {
        return React.createElement(LeadGenFormContainer, {
          ctaCopy: copy
        });
      }));
    }
  }, {
    key: "renderHeadingLines",
    value: function renderHeadingLines(lines, type) {
      var _this$props3 = this.props,
          cmsModuleId = _this$props3.cmsModuleId,
          interpolator = _this$props3.interpolator;
      return wrapLines(lines.map(interpolator).map(function (line, index) {
        return renderMarkdown(line, "hero_".concat(cmsModuleId, "_").concat(type, "_").concat(index));
      }), "hero__layout__content__".concat(type, "__line"));
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames2;

      var _this$props4 = this.props,
          horizontalAlignment = _this$props4.horizontalAlignment,
          desktopImageUrl = _this$props4.desktopImageUrl,
          headerCtaCopy = _this$props4.headerCtaCopy,
          heroTextColor = _this$props4.heroTextColor,
          hideHeaderCta = _this$props4.hideHeaderCta,
          isRaf = _this$props4.isRaf,
          isWelcomeHero = _this$props4.isWelcomeHero,
          isLeadCapture = _this$props4.isLeadCapture,
          legal = _this$props4.legal,
          mobileImageUrl = _this$props4.mobileImageUrl,
          promoAlias = _this$props4.promoAlias,
          subtitle = _this$props4.subtitle,
          _this$props4$textJust = _this$props4.textJustification,
          textJustification = _this$props4$textJust === void 0 ? 'left' : _this$props4$textJust,
          title = _this$props4.title,
          titleSize = _this$props4.titleSize,
          _this$props4$vertical = _this$props4.verticalAlignment,
          verticalAlignment = _this$props4$vertical === void 0 ? 'middle' : _this$props4$vertical;
      var displayFriendbuyWidget = this.state.displayFriendbuyWidget;
      return React.createElement("div", {
        className: classNames((_classNames2 = {}, _defineProperty(_classNames2, "hero hero--website-2-0 hero--".concat(heroTextColor), true), _defineProperty(_classNames2, 'hero--raf', isRaf), _defineProperty(_classNames2, 'hero--welcome', isWelcomeHero), _classNames2))
      }, displayFriendbuyWidget && React.createElement(FriendbuyWidgetContainer, {
        onClose: this.handleFriendbuyWidgetClose
      }), !hideHeaderCta && React.createElement(PortalContent, {
        id: "nav-cta"
      }, React.createElement(CallToAction, {
        action: ACTIONS.LINK,
        extraClass: "bt--primary bt--sm bt--text-sm header__bt",
        onClick: this.handleCtaClick,
        to: promoAlias ? "/pricing/".concat(promoAlias) : '/pricing'
      }, headerCtaCopy || React.createElement(FormattedMessage, messages.navAction))), React.createElement("div", {
        className: classNames('hero__placeholder', 'hero__placeholder--sm', "hero__placeholder--sm--".concat(verticalAlignment)),
        style: mobileImageUrl ? {
          backgroundImage: "url(".concat(mobileImageUrl, ")")
        } : {}
      }), React.createElement("div", {
        className: classNames('hero__placeholder', 'hero__placeholder--md', "hero__placeholder--md--".concat(verticalAlignment)),
        style: desktopImageUrl ? {
          backgroundImage: "url(".concat(desktopImageUrl, ")")
        } : {}
      }), React.createElement("div", {
        className: classNames('hero__layout', "hero__layout--".concat(horizontalAlignment), "hero__layout--".concat(verticalAlignment), "hero__layout--".concat(textJustification, "-justify"))
      }, React.createElement("div", {
        className: "hero__layout__content"
      }, React.createElement("h1", {
        className: classNames('hero__layout__content__title', "hero__layout__content__title--".concat(titleSize))
      }, this.renderHeadingLines(title, 'title')), !isEmpty(subtitle) && React.createElement("h2", {
        className: "hero__layout__content__subtitle"
      }, this.renderHeadingLines(subtitle, 'subtitle')), isLeadCapture ? this.renderLeadCapture() : this.renderCtaSection(), // eslint-disable-next-line react/no-danger
      legal && React.createElement("p", {
        className: "hero__terms",
        dangerouslySetInnerHTML: {
          __html: legal
        }
      }))));
    }
  }]);

  return HeroV2;
}(Component);
HeroV2.propTypes = {
  horizontalAlignment: PropTypes.oneOf(['left', 'center', 'right']).isRequired,
  cmsModuleId: PropTypes.string,
  ctaClick: PropTypes.func.isRequired,
  ctas: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.shape({
    color: PropTypes.string,
    copy: PropTypes.string,
    url: PropTypes.string
  }), PropTypes.shape({
    color: PropTypes.string,
    copy: PropTypes.string,
    theme: PropTypes.string,
    videoId: PropTypes.string
  })])).isRequired,
  desktopImageUrl: PropTypes.string,
  headerCtaCopy: PropTypes.string,
  heroTextColor: PropTypes.oneOf(['light', 'dark']).isRequired,
  hideHeaderCta: PropTypes.bool,
  interpolator: PropTypes.func.isRequired,
  isLeadCapture: PropTypes.bool,
  isRaf: PropTypes.bool,
  isWelcomeHero: PropTypes.bool,
  legal: PropTypes.string,
  mobileImageUrl: PropTypes.string,
  promoAlias: PropTypes.string,
  setPagePromotion: PropTypes.func.isRequired,
  subtitle: PropTypes.arrayOf(PropTypes.string),
  textJustification: PropTypes.oneOf(['left', 'far-left', 'center', 'right']),
  title: PropTypes.arrayOf(PropTypes.string).isRequired,
  titleSize: PropTypes.oneOf(['display', 'display-small']),
  useSellHeader: PropTypes.func.isRequired,
  verticalAlignment: PropTypes.oneOf(['top', 'top-split', 'middle', 'middle-split', 'bottom', 'bottom-split'])
};